(function () {
  'use strict';

  var STOREFRONT_ACCESS_TOKEN = '29c84a7541ad5d1e6e246765c08e04ad';
  var STOREFRONT_API_VERSION = '2026-07';

  var cataloguePromise = null;
  var renderQueued = false;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeId(value) {
    return String(value || '').replace(/[^A-Za-z0-9_-]/g, '-');
  }

  function propertyValue(properties, wantedKey) {
    if (!properties || typeof properties !== 'object') return '';

    var wanted = String(wantedKey || '').trim().toLowerCase();
    var keys = Object.keys(properties);

    for (var i = 0; i < keys.length; i++) {
      if (String(keys[i]).trim().toLowerCase() === wanted) {
        return String(properties[keys[i]] || '');
      }
    }

    return '';
  }

  function normaliseUploadUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }

  function hidePrivateTokenProperties() {
    var metadata = document.querySelectorAll(
      '.ajaxcart__product-meta'
    );

    Array.prototype.forEach.call(metadata, function (element) {
      if (/^_TM\b/i.test(String(element.textContent || '').trim())) {
        element.style.display = 'none';
      }
    });
  }

  function renderHostedPreview(placeholder, properties) {
    var frontUrl = normaliseUploadUrl(
      propertyValue(properties, '_TM Preview Front')
    );
    var backUrl = normaliseUploadUrl(
      propertyValue(properties, '_TM Preview Back')
    );

    if (!frontUrl) return false;

    var backDesign = propertyValue(properties, 'Back Design');
    var sides = [
      {
        url: frontUrl,
        label: backUrl
          ? 'Front'
          : (/same as front/i.test(backDesign) ? 'Front / Back' : 'Front')
      }
    ];

    if (backUrl) {
      sides.push({url: backUrl, label: 'Back'});
    }

    placeholder.innerHTML = sides.map(function (side) {
      return (
        '<div class="tm-cart-side">' +
          '<img class="tm-cart-hosted-preview" src="' +
            escapeHtml(side.url) + '" alt="Token preview">' +
          (side.label
            ? '<span class="tm-cart-side__label">' +
                escapeHtml(side.label) +
              '</span>'
            : '') +
        '</div>'
      );
    }).join('');

    placeholder.style.display = 'flex';
    placeholder.setAttribute('data-tm-rendered', 'hosted-preview');

    var row = placeholder.closest('.ajaxcart__row');
    if (row) {
      var standardImage = row.querySelector('.ajaxcart__standard-image');
      if (standardImage) standardImage.style.display = 'none';
    }

    return true;
  }

  function decodeTokenMakerConfig(properties) {
    if (!properties || typeof properties !== 'object') return null;

    var chunks = Object.keys(properties)
      .map(function (key) {
        var match = key.match(/^_TM Config (\d+)$/);
        if (!match) return null;

        return {
          number: parseInt(match[1], 10),
          value: String(properties[key] || '')
        };
      })
      .filter(Boolean)
      .sort(function (a, b) {
        return a.number - b.number;
      });

    if (!chunks.length) return null;

    for (var i = 0; i < chunks.length; i++) {
      if (chunks[i].number !== i + 1) return null;
    }

    try {
      var config = JSON.parse(
        chunks.map(function (chunk) {
          return chunk.value;
        }).join('')
      );

      if (!config || Number(config.version) !== 1 || !config.front) {
        return null;
      }

      return config;
    } catch (error) {
      return null;
    }
  }

  function makeCurvePath(textState) {
    var minimumRadius = 30;
    var maximumRadius = 180;
    var strength = Number(textState.curve || 0) / 100;

    var radius =
      maximumRadius -
      strength * (maximumRadius - minimumRadius);

    var centreX = 50;
    var centreY = 80;
    var spanDegrees = 160;
    var isConvex = textState.mode === 'convex';

    var circleCentreY = isConvex
      ? centreY + radius
      : centreY - radius;

    var apexAngle = isConvex ? -90 : 90;

    var leftAngle = isConvex
      ? apexAngle - spanDegrees
      : apexAngle + spanDegrees;

    var rightAngle = isConvex
      ? apexAngle + spanDegrees
      : apexAngle - spanDegrees;

    function pointOnCircle(angleDegrees) {
      var angle = angleDegrees * Math.PI / 180;

      return {
        x: centreX + radius * Math.cos(angle),
        y: circleCentreY + radius * Math.sin(angle)
      };
    }

    var leftPoint = pointOnCircle(leftAngle);
    var rightPoint = pointOnCircle(rightAngle);
    var sweepFlag = isConvex ? 1 : 0;

    return (
      'M ' +
      leftPoint.x + ' ' + leftPoint.y +
      ' A ' +
      radius + ' ' + radius +
      ' 0 0 ' +
      sweepFlag + ' ' +
      centreX + ' ' + centreY +
      ' A ' +
      radius + ' ' + radius +
      ' 0 0 ' +
      sweepFlag + ' ' +
      rightPoint.x + ' ' + rightPoint.y
    );
  }

  function textMarkup(textState, uniquePrefix, index) {
    if (
      !textState ||
      !Number(textState.active) ||
      !String(textState.text || '').trim()
    ) {
      return '';
    }

    var fontSize = 9.5 * Number(textState.scale || 1);
    var spacing = Number(textState.spacing || 0);
    var fill = escapeHtml(textState.fill || '#ffffff');
    var outlineWidth = Number(textState.outlineWidth || 0);
    var outline = outlineWidth > 0
      ? escapeHtml(textState.outline || '#000000')
      : 'none';
    var font = escapeHtml(
      textState.font || 'Arial, Helvetica, sans-serif'
    );

    var x = Number(textState.x || 0);
    var y = Number(textState.y || 0);

    var common =
      'font-family="' + font + '" ' +
      'font-size="' + fontSize + '" ' +
      'font-weight="800" ' +
      'letter-spacing="' + spacing + '" ' +
      'fill="' + fill + '" ' +
      'stroke="' + outline + '" ' +
      'stroke-width="' + outlineWidth + '" ' +
      'stroke-linejoin="round" ' +
      'paint-order="stroke fill"';

    var transform =
      'translate(' + x + ' ' + y + ')';

    if (textState.mode === 'straight') {
      return (
        '<g transform="' + transform + '">' +
          '<text ' +
            'x="50" y="80" ' +
            'text-anchor="middle" ' +
            'dominant-baseline="middle" ' +
            common +
          '>' +
            escapeHtml(textState.text) +
          '</text>' +
        '</g>'
      );
    }

    var pathId = safeId(uniquePrefix + '-curve-' + index);

    return (
      '<defs>' +
        '<path id="' + pathId + '" d="' +
          escapeHtml(makeCurvePath(textState)) +
        '"></path>' +
      '</defs>' +
      '<g transform="' + transform + '">' +
        '<text text-anchor="middle" dominant-baseline="middle" ' +
          common + '>' +
          '<textPath href="#' + pathId + '" startOffset="50%">' +
            escapeHtml(textState.text) +
          '</textPath>' +
        '</text>' +
      '</g>'
    );
  }

  function textSvg(sideConfig, uniquePrefix) {
    return (
      '<svg class="tm-cart-token__text" viewBox="0 0 100 100" ' +
        'preserveAspectRatio="none" aria-hidden="true">' +
        textMarkup(sideConfig.text1, uniquePrefix, 1) +
        textMarkup(sideConfig.text2, uniquePrefix, 2) +
      '</svg>'
    );
  }

  async function storefrontGraphql(query, variables) {
    var shop =
      window.Shopify && window.Shopify.shop
        ? window.Shopify.shop
        : 'back2base-ix.myshopify.com';

    var response = await fetch(
      'https://' + shop + '/api/' +
      STOREFRONT_API_VERSION +
      '/graphql.json',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token':
            STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify({
          query: query,
          variables: variables || {}
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        'Storefront API HTTP ' + response.status
      );
    }

    var payload = await response.json();

    if (payload.errors && payload.errors.length) {
      throw new Error(
        payload.errors.map(function (error) {
          return error.message;
        }).join('; ')
      );
    }

    return payload.data;
  }

  async function loadArtworkCatalogue() {
    if (cataloguePromise) return cataloguePromise;

    cataloguePromise = (async function () {
      var query = `
        query TokenArtwork(
          $first: Int!,
          $after: String
        ) {
          metaobjects(
            type: "token_artwork"
            first: $first
            after: $after
          ) {
            nodes {
              handle
              imageField: field(key: "image") {
                reference {
                  ... on MediaImage {
                    image {
                      url
                    }
                  }
                }
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      `;

      var byHandle = {};
      var after = null;

      do {
        var data = await storefrontGraphql(
          query,
          {
            first: 250,
            after: after
          }
        );

        var connection = data && data.metaobjects;

        if (!connection) {
          throw new Error(
            'Token artwork catalogue was not returned.'
          );
        }

        (connection.nodes || []).forEach(function (node) {
          var url =
            node &&
            node.imageField &&
            node.imageField.reference &&
            node.imageField.reference.image
              ? node.imageField.reference.image.url
              : '';

          if (node && node.handle && url) {
            byHandle[node.handle] = url;
          }
        });

        after =
          connection.pageInfo &&
          connection.pageInfo.hasNextPage
            ? connection.pageInfo.endCursor
            : null;

      } while (after);

      return byHandle;
    })();

    return cataloguePromise;
  }

  function sideMarkup(
    sideConfig,
    artworkByHandle,
    uniquePrefix,
    label
  ) {
    if (!sideConfig) return '';

    var backgroundMarkup = '';
    var backgroundStyle = '';

    if (
      sideConfig.background &&
      sideConfig.background.mode === 'solid'
    ) {
      backgroundStyle =
        'background:' +
        escapeHtml(
          sideConfig.background.colour || '#111111'
        ) +
        ';';
    } else {
      var backgroundUrl =
        sideConfig.background
          ? artworkByHandle[
              sideConfig.background.handle
            ]
          : '';

      if (backgroundUrl) {
        backgroundMarkup =
          '<img class="tm-cart-token__background" ' +
          'src="' + escapeHtml(backgroundUrl) + '" alt="">';
      } else {
        backgroundStyle = 'background:#111111;';
      }
    }

    var iconUrl =
      sideConfig.icon
        ? artworkByHandle[sideConfig.icon.handle]
        : '';

    var iconMarkup = '';

    if (iconUrl) {
      var iconX = Number(sideConfig.icon.x || 0);
      var iconY = Number(sideConfig.icon.y || 0);
      var rotation =
        Number(sideConfig.icon.rotation || 0);
      var zoom = Number(sideConfig.icon.zoom || 1);

      iconMarkup =
        '<img class="tm-cart-token__icon" ' +
        'src="' + escapeHtml(iconUrl) + '" alt="" ' +
        'style="transform:' +
          'translate3d(' +
          iconX + '%,' +
          iconY + '%,0) ' +
          'rotate(' +
          rotation + 'deg) ' +
          'scale(' +
          zoom +
          ');">';
    }

    return (
      '<div class="tm-cart-side">' +
        '<div class="tm-cart-token" style="' +
          backgroundStyle + '">' +
          backgroundMarkup +
          iconMarkup +
          textSvg(sideConfig, uniquePrefix) +
        '</div>' +
        (
          label
            ? '<span class="tm-cart-side__label">' +
                escapeHtml(label) +
              '</span>'
            : ''
        ) +
      '</div>'
    );
  }

  function renderLinePreview(
    placeholder,
    config,
    artworkByHandle,
    lineKey
  ) {
    var sides = [];

    sides.push({
      config: config.front,
      label: 'Front'
    });

    if (
      config.sidedness === 'double' &&
      config.back === 'different' &&
      config.backSide
    ) {
      sides.push({
        config: config.backSide,
        label: 'Back'
      });
    } else if (
      config.sidedness === 'double' &&
      config.back === 'same'
    ) {
      sides[0].label = 'Front / Back';
    }

    placeholder.innerHTML =
      sides.map(function (side, index) {
        return sideMarkup(
          side.config,
          artworkByHandle,
          safeId(lineKey + '-' + index),
          side.label
        );
      }).join('');

    placeholder.style.display = 'flex';

    placeholder.setAttribute(
      'data-tm-rendered',
      'true'
    );

    var row = placeholder.closest('.ajaxcart__row');

    if (row) {
      var standardImage =
        row.querySelector(
          '.ajaxcart__standard-image'
        );

      if (standardImage) {
        standardImage.style.display = 'none';
      }
    }
  }

  async function renderCartPreviews() {
    renderQueued = false;
    hidePrivateTokenProperties();

    var placeholders = Array.prototype.slice.call(
      document.querySelectorAll(
        '.tm-cart-preview:not([data-tm-rendered])'
      )
    );

    if (!placeholders.length) return;

    var cartResponse = await fetch(
      '/cart.js',
      {
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      }
    );

    if (!cartResponse.ok) return;

    var cart = await cartResponse.json();
    var itemsByKey = {};

    (cart.items || []).forEach(function (item) {
      itemsByKey[item.key] = item;
    });

    var work = [];

    placeholders.forEach(function (placeholder) {
      var lineKey =
        placeholder.getAttribute(
          'data-tm-line-key'
        );

      var item = itemsByKey[lineKey];

      if (!item) return;

      if (
        renderHostedPreview(
          placeholder,
          item.properties
        )
      ) {
        return;
      }

      var config =
        decodeTokenMakerConfig(
          item.properties
        );

      if (!config) {
        placeholder.setAttribute(
          'data-tm-rendered',
          'not-token-maker'
        );
        return;
      }

      work.push({
        placeholder: placeholder,
        config: config,
        lineKey: lineKey
      });
    });

    if (!work.length) return;

    try {
      var artworkByHandle =
        await loadArtworkCatalogue();

      work.forEach(function (item) {
        renderLinePreview(
          item.placeholder,
          item.config,
          artworkByHandle,
          item.lineKey
        );
      });
    } catch (error) {
      if (window.console && console.warn) {
        console.warn(
          'Token Maker cart preview:',
          error
        );
      }
    }
  }

  function scheduleRender() {
    if (renderQueued) return;

    renderQueued = true;

    window.requestAnimationFrame(function () {
      renderCartPreviews().catch(function (error) {
        renderQueued = false;

        if (window.console && console.warn) {
          console.warn(
            'Token Maker cart preview:',
            error
          );
        }
      });
    });
  }

  function addStyles() {
    if (
      document.getElementById(
        'TokenMakerCartPreviewStyles'
      )
    ) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'TokenMakerCartPreviewStyles';

    style.textContent = `
      .tm-cart-preview {
        width: 100%;
        align-items: flex-start;
        justify-content: center;
        gap: 5px;
        margin: 0 auto;
      }

      .tm-cart-side {
        min-width: 0;
        flex: 1 1 0;
        text-align: center;
      }

      .tm-cart-token {
        width: 100%;
        max-width: 84px;
        aspect-ratio: 1 / 1;
        position: relative;
        margin: 0 auto;
        overflow: hidden;
        border-radius: 50%;
        background: #111111;
        box-shadow:
          0 0 0 1px rgba(0,0,0,0.32);
      }

      .tm-cart-token__background,
      .tm-cart-token__icon,
      .tm-cart-token__text {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        display: block;
      }

      .tm-cart-token__background {
        z-index: 1;
        object-fit: cover;
        max-width: none;
      }

      .tm-cart-token__icon {
        z-index: 2;
        object-fit: contain;
        max-width: none;
        transform-origin: center center;
      }

      .tm-cart-token__text {
        z-index: 3;
        overflow: visible;
        pointer-events: none;
      }

      .tm-cart-side__label {
        display: block;
        margin-top: 4px;
        font-size: 9px;
        line-height: 1.2;
        opacity: 0.72;
      }

      .tm-cart-hosted-preview {
        width: 100%;
        max-width: 84px;
        aspect-ratio: 1 / 1;
        display: block;
        margin: 0 auto;
        border-radius: 50%;
        object-fit: contain;
        box-shadow: 0 0 0 1px rgba(0,0,0,0.32);
      }

      .ajaxcart__product-image
      .tm-cart-preview {
        text-decoration: none;
      }
    `;

    document.head.appendChild(style);
  }

  function initialise() {
    addStyles();

    var cartContainer =
      document.getElementById(
        'CartContainer'
      );

    if (!cartContainer) return;

    var observer =
      new MutationObserver(function () {
        scheduleRender();
      });

    observer.observe(
      cartContainer,
      {
        childList: true,
        subtree: true
      }
    );

    scheduleRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );
  } else {
    initialise();
  }
})();
